import { TableCell } from "@mui/material";
import { Theme, styled } from "@mui/material/styles";
import { TABLE_BG_COLOR, TABLE_BORDER_COLOR } from "./constants";

const responsiveTableCellStyles = (theme: Theme) => ({
  [theme.breakpoints.down("xxl")]: { fontSize: 14, lineHeight: 1.4, padding: "8px 12px" },
  [theme.breakpoints.down("xl")]: { fontSize: 12, lineHeight: 1.3, padding: "6px 8px" },
  [theme.breakpoints.down("lg")]: { fontSize: 12, lineHeight: 1.2, padding: "4px 6px" },
});

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: TABLE_BG_COLOR,
  borderRight: `1px solid ${TABLE_BORDER_COLOR}`,
  borderColor: TABLE_BORDER_COLOR,

  ...responsiveTableCellStyles(theme),
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  borderRight: `1px solid ${TABLE_BORDER_COLOR}`,
  borderColor: TABLE_BORDER_COLOR,

  ...responsiveTableCellStyles(theme),
}));
